import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  OnDestroy,
  ViewChild,
  ElementRef,
  ChangeDetectorRef
} from '@angular/core';
import { Subject, timer } from 'rxjs';
import { tap, debounce, takeUntil, filter } from 'rxjs/operators';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-site-header',
  templateUrl: './site-header.component.html',
  styleUrls: ['./site-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SiteHeaderComponent implements OnInit, OnDestroy {
    
  private exploreFocused = false;
  public exploreHoverSubject = new Subject<boolean>();
  private ngUnsubscribe = new Subject();

  private _exploreShown = false;

  get exploreShown(): boolean {
    return this._exploreShown;
  }
  set exploreShown(value: boolean) {
    this._exploreShown = value;
    this.changeDetector.markForCheck();
  }

  @ViewChild('siteHeader')
  siteHeader: ElementRef;

  constructor(
    private changeDetector: ChangeDetectorRef,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.initExploreMenu();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.changeDetector.detach();
  }

  handleMenuEnter() {
    this.exploreHoverSubject.next(true);
  }

  handleMenuLeave() {
    this.exploreHoverSubject.next(false);
  }

  private initExploreMenu() {
    // hide menu on navigation
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe((event: NavigationEnd) => {
        this.exploreShown = false;
      });

    this.exploreHoverSubject.asObservable()
      .pipe(
        tap((hover) => this.exploreFocused = hover),
        // throttle mouseleave
        debounce((hover) => timer(hover ? 0 : 100)),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe((hover) => {
        if (hover) {
          this.exploreShown = true;
        } else if (!this.exploreFocused) { // only trigger after delay
          this.exploreShown = false;
        }
      });
  }

}
